import { getExternalUrl } from "../config/urls";
export function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <figure className="footer-logo">
              <img alt="Logo - KBW e. V." src="/media/kbw-logo-footer.svg" />
            </figure>
          </div>
          <div className="col-xs-12 col-sm-8">
            <figure className="footer-claim">
              <img alt="wissen. teilen. bewegen" src="/media/kbw-claim.svg" />
            </figure>
          </div>
          <div className="col-xs-12">
            <p className="text-center">
              <strong>Newsletter</strong>
            </p>
            <form
              className="footer-newsletter"
              action={getExternalUrl("/service/newsletter")}
              method="post"
            >
              <input
                type="email"
                name="newsletterEmail"
                className="form-control"
                id="newsletterEmail"
                placeholder="E-Mail-Adresse"
                required
              />
              <button
                type="submit"
                name="newsletter"
                className="btn btn-primary"
              >
                Weiter
              </button>
              <input
                type="hidden"
                name="DXScript"
                value="4_154,1_11,1_12,1_252,1_23,..."
              />
              <input
                type="hidden"
                name="DXCss"
                value="1_210,0_1649,1_68,1_69,..."
              />
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <p>
              <strong>Zertifizierungen</strong>
            </p>
            <div className="footer-certs">
              <figure className="footer-certs-item">
                <img
                  src="/media/iso-en-2015.png"
                  alt="Zertifizierung-DIN EN ISO 9001"
                />
                <figcaption className="sr-only">
                  zertifiziert nach DIN EN-ISO 9001
                </figcaption>
              </figure>
              <figure className="footer-certs-item">
                <img
                  src="/media/sustainable_meetings_berlin_kbw.png"
                  alt="sustainable meetings Berlin - high performer"
                />
                <figcaption className="sr-only">
                  sustainable meetings Berlin - high performer
                </figcaption>
              </figure>
            </div>
          </div>
          <div className="col-xs-12 col-sm-4">
            <p className="text-center">
              <strong>Social Media</strong>
            </p>
            <ul className="footer-social-media">
              <li>
                <a
                  href="https://www.facebook.com/KBW.e.V/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zu unserem Facebook-Profil."
                >
                  <i className="fa fa-facebook" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://de.linkedin.com/company/kommunales-bildungswerk-e-v-"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zu unserem LinkedIn-Profil."
                >
                  <i className="fa fa-linkedin" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com/KommunalesBW"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zu unserem X-Profil."
                >
                  <i className="fa fa-twitter" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/kommunalesbildungswerk"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Zu unserem Instagram-Profil."
                >
                  <i className="fa fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-3 col-md-offset-1">
            <ul className="footer-btns">
              <li>
                <a href="https://dozent.kbw.de/" className="btn btn-primary">
                  Dozenten Login
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href={getExternalUrl("/ueber-uns/kooperationen")}
                  className="btn btn-outline-primary"
                >
                  Kooperationen
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a href={getExternalUrl("/service/download")} className="btn btn-outline-primary">
                  Downloads
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
